import moment from 'moment';

interface IProps {
  time: Date | string;
  fromFormat?: string;
  format?: string;
  dateOnly?: boolean;
  fromNow?: boolean;
}

export default function Moment(props: IProps) {
  const { time, format, dateOnly, fromFormat, fromNow } = props;

  let momentFormat = 'DD MMM YYYY, h:mm a';

  if (dateOnly) {
    momentFormat = 'DD MMM YYYY';
  }

  if (format) {
    momentFormat = format;
  }

  if (fromNow && moment() < moment(time).add(1, 'days')) {
    return <>{moment(time).fromNow()}</>;
  }
  return <>{moment(time, fromFormat).format(momentFormat)}</>;
}
